import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const ImportFiles = lazyLoader(
  () => import("Containers/ImportFiles/ImportFiles")
);

export const ImportFilesPage = () => {
  return (
    <Layout>
      <ImportFiles />
    </Layout>
  );
};
